import { FC } from 'react';

import { useEventContext } from '../../hooks/contexts/event.context';
import { useI18nContext } from '../../hooks/contexts/i18n.context';
import { useModalContext } from '../../hooks/contexts/modal.context';
import * as Styles from './term-modal.styles';

const TermModal: FC = () => {
  const { translate } = useI18nContext();
  const { toggleModal } = useModalContext();

  const { event } = useEventContext();

  const parsed = JSON.parse(event?.attributes?.terms?.value ?? '{}');

  const title = parsed.title?.trim() ?? '';
  const description = parsed.description;

  return (
    <Styles.Body>
      <Styles.Text>
        {title}
      </Styles.Text>
      <Styles.TextInfo dangerouslySetInnerHTML={{ __html : description }}>
      </Styles.TextInfo>
      <Styles.BtnContainer>
        <Styles.CutomBtn onClick={() => toggleModal({ open : false })}>
          {translate(['INFORMATION', 'UNDERSTOOD'])}
        </Styles.CutomBtn>
      </Styles.BtnContainer>
    </Styles.Body>
  );
};

export default TermModal;
